import React from 'react';
import { Dialog, Button, Box, Typography, Stack } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';

interface LockedDialogProps {
  isOpen: boolean;
  userName: string;
  onClose: () => void;
}

const LockedOrder: React.FC<LockedDialogProps> = ({ isOpen, userName, onClose }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        zIndex: 1400,
        '& .MuiDialog-paper': {
          borderRadius: 0,
          maxWidth: 450,
          width: '100%',
          m: 2,
          backgroundColor: 'white'
        },
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.7)'
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: 3,
          textAlign: 'center',
          backgroundColor: 'white'
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            backgroundColor: 'rgba(254, 122, 122, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2
          }}
        >
          <Typography variant="h1" color="error">
            <FontAwesomeIcon icon={faLock} />
          </Typography>
        </Box>

        <Typography
          variant="h3"
          sx={{
            mb: 3,
            color: '#303030',
            fontSize: '1.2rem',
            fontWeight: 800
          }}
        >
          You will be unable to access the order <br />
          until{' '}
          <Typography
            variant="h3"
            color="error"
            sx={{
              display: 'inline',
              mb: 3,
              fontSize: '1.2rem',
              fontWeight: 800
            }}
          >
            {userName}
          </Typography>{' '}
          has closed it
        </Typography>

        <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
          <Button
            fullWidth
            variant="outlined"
            onClick={onClose}
            sx={{
              textTransform: 'none',
              color: '#303030',
              borderColor: '#d0d0d0',
              borderRadius: 0,
              fontSize: '0.9rem',
              '&:hover': {
                borderColor: '#c0c0c0',
                backgroundColor: 'rgba(0, 0, 0, 0.03)'
              }
            }}
          >
            Return to Orders
          </Button>
        </Stack>
      </Box>
    </Dialog>
  );
};

export default LockedOrder;
